var React = require('react');

function Selected (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("circle",{"id":"selected-a","cx":"12.5","cy":"12.5","r":"4.5"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"selected-b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#selected-a"})),React.createElement("use",{"fill":"#F1F4FC","fillRule":"nonzero","xlinkHref":"#selected-a","key":1}),React.createElement("g",{"mask":"url(#selected-b)","key":2},[React.createElement("path",{"fill":"#FFF","d":"M0 0h25v25H0z","key":0}),React.createElement("path",{"fill":"#424242","d":"M0 0h25v25H0z","key":1})])])]);
}

Selected.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = Selected;

Selected.default = Selected;
